import { createAction } from '@mendeley-internal/lib-js-redux-actions';
import api from '../services/api/request';

export const getAuthors = createAction(
  'GET_AUTHORS',
  ({ documentId }) => api.get('authors', { params: { documentId } }).setCritical(false),
  ({ documentId }) => ({ documentId })
);



// WEBPACK FOOTER //
// ./src/universal/ui/actions/authors.js